export default __webpack_public_path__ + "static/media/woman-with-email-notification.3378da73.svg";